<div class="container-fluid">
    <div class="row">

      <div class="card shadow-sm p-0">
        <div class="card-header">
          <h3 class="card-title">{{ campaignId ? 'Update Campaign' : 'Edit Campaign' }} </h3>
        </div>
        <div class="card-body">
          <campaigns-form
            [campaign]="campaign"
          />
        </div>
      </div>
    </div>
    
  </div>
  